/* eslint-disable @typescript-eslint/no-explicit-any */
export var once = function once(fn) {
  var called = false;
  var result;
  var newFn = function newFn() {
    if (called) {
      return result;
    }
    called = true;
    result = fn.apply(void 0, arguments);
    return result;
  };
  return newFn;
};
//# sourceMappingURL=once.js.map